
import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  onMounted,
  Ref,
  PropType
} from "vue";
import { useRouter } from "vue-router";
import { useToast, useConfirm } from "../../modules/message";
import {
  useOrcamentoService,
  StatusRenovacaoLicencaPayload
} from "../../modules/business/orcamento/orcamentoBusiness";

interface StatusState {
  statusList: Array<StatusRenovacaoLicencaPayload>;
  stateReady: boolean;
  loadings: Array<Ref<boolean>>;
}

export default defineComponent({
  setup(props) {
    const router = useRouter();
    const state = reactive<StatusState>({
      statusList: [],
      stateReady: false,
      loadings: []
    });

    const stateLoading = computed(() => state.loadings.length !== 0);

    const qtdErros = computed(
      () => state.statusList.filter((s) => s.temErro).length
    );

    const resultsStatus = computed(() => ({
      content: state.statusList,
      page: {
        size: state.statusList.length,
        number: 0,
        totalElements: state.statusList.length,
        totalPages: 1
      }
    }));

    const carregarStatus = () => {
      const { getStatusLicencas, loading, data } = useOrcamentoService();
      state.loadings.push(loading);
      getStatusLicencas(props.idOrcamento)
        .then(() => {
          state.statusList =
            (data.value as Array<StatusRenovacaoLicencaPayload>) ?? [];
          state.loadings.splice(state.loadings.indexOf(loading), 1);
          state.stateReady = true;
        })
        .catch(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    };

    const reenviar = (status: StatusRenovacaoLicencaPayload) => {
      useConfirm().require({
        message: `Reenviar a licença da placa ${status.placa} ao robô?`,
        header: "Confirmar reenvio",
        icon: "pi pi-info-circle",
        accept: () => {
          const { reenviarLicencaOrgao, loading } = useOrcamentoService();
          state.loadings.push(loading);
          reenviarLicencaOrgao(props.idOrcamento, status.idLicencaOrgao)
            .then(() => {
              state.loadings.splice(state.loadings.indexOf(loading), 1);
              useToast().success("Reenvio agendado");
              carregarStatus();
            })
            .catch(() => {
              state.loadings.splice(state.loadings.indexOf(loading), 1);
            });
        }
      });
    };

    const abrirLicenca = (idLicenca: number) => {
      const url = router.resolve({
        name: "licenca-edit",
        params: { idLicenca: idLicenca + "" }
      }).fullPath;
      window.open(url, "_blank");
    };

    const formatStatus = (status?: string | null): string => {
      if (!status) return "";
      return status.replaceAll("_", " ").toLowerCase();
    };

    onMounted(() => carregarStatus());

    return {
      qtdErros,
      resultsStatus,
      carregarStatus,
      reenviar,
      abrirLicenca,
      formatStatus,
      stateLoading,
      ...toRefs(state)
    };
  },
  props: {
    idOrcamento: {
      type: Number,
      required: true
    },
    parentLoading: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  }
});
